import { required } from "@corporate-tailwind/corp-form";
import { CountryDto } from "./country.model";

export class CustomerEmailValidationDto {
    id: Number | null = null;
    token: string | null = null;
    dateSend: Date | null = null;
    dateConfirmed: Date | null = null;
}

export class CustomerEmailValidationSchema extends CustomerEmailValidationDto {
    static schema = {
        id: { type: Number, builderOption: required },
        itsMeId: { type: String, builderOption: required } ,
        beEidSn: { type: String, builderOption: required } ,
        beNationalNumber: { type: String, builderOption: required } ,
        idDocumentIssuanceDate: { type: Date, builderOption: required } ,
        idDocumentExpiryDate: { type: Date, builderOption: required } ,
        idDocumentType: { type: String, builderOption: required } ,
        idIssuingCountry: {type: CountryDto, builderOption: required } 
    };

}
